import { render, staticRenderFns } from "./public-menu.vue?vue&type=template&id=59f83106&scoped=true&"
import script from "./public-menu.ts?vue&type=script&lang=ts&"
export * from "./public-menu.ts?vue&type=script&lang=ts&"
import style0 from "./public-menu.scss?vue&type=style&index=0&id=59f83106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f83106",
  null
  
)

export default component.exports